import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Stack, Container } from "react-bootstrap";
import toast from "react-hot-toast";
import OtpInput from 'react-otp-input';
import { useNavigate } from "react-router-dom";

import { store } from "../store";
import { customToastStyle } from "../configs/constants";
import { isExistUserApi, setSignMessageApi, verifyOtpApi, getUserApi, loginApi } from "../apis/coupon";
import SignUp from "./SignUp";

export default function SignIn({
    show,
    handleClose
}: {
    show: boolean;
    handleClose: () => void;
}) {
    const nav = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [otp, setOtp] = useState("");
    const [showOtp, setShowOtp] = useState(false);
    const [showSignUp, setShowSignUp] = useState(false);
    const [showTerms, setShowTerms] = useState(false);

    const [, setAccount] = store.useState("account");
    const [, setStoreEmail] = store.useState("email");
    const [, setUserInfo] = store.useState("userInfo");

    const handleSignInHandler = async () => {
        if (!password || !email) {
            return toast("Please input fields", customToastStyle)
        }
        const res = await loginApi(email, password);
        if (res) {
            await verifyTerms()
            nav("/dashboard");
        } else {
            return toast("Please check credentials", customToastStyle);
        }
    }

    const handleSignUp = async () => {
        if (!password || !confirmPassword || !email) {
            return toast("Please input fields", customToastStyle)
        }
        if (confirmPassword !== password) {
            return toast("Please check password", customToastStyle)
        }

        // check email address already existed in db

        if (await isExistUserApi(email)) {
            return toast("Already existed user", customToastStyle);
        }

        setStoreEmail(email);

        await signUpCaller();
    }

    const signUpCaller = async () => {
        setShowSignUp(false);
        // save data in db
        const res = await setSignMessageApi({ address: email, signature: password })

        if (res) {
            return setShowOtp(true);
        } else {
            return toast("Error to save in data", customToastStyle);
        }
    }

    const handleVerify = async () => {
        const res = await verifyOtpApi(email, otp);
        if (res) {
            return setShowTerms(true);
        }
        setOtp("");
        return toast("OTP code error", customToastStyle)
    }

    const verifyTerms = async () => {
        setUserInfo(await getUserApi(email));
        setAccount(email);
        setStoreEmail(email);
    }


    return (
        <Modal show={show} centered onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: 18, fontWeight: "bold" }}>
                    {
                        showSignUp ? "Sign Up" : "Sign In"
                    }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <SignUp show={showTerms} handleClose={verifyTerms} />
                {
                    showOtp ?
                        <Container className="w-100 d-flex flex-column">
                            <div className="w-100 d-flex justify-content-center mt-2">
                                <OtpInput
                                    value={otp}
                                    onChange={setOtp}
                                    numInputs={6}
                                    inputStyle={{ width: 40, height: 40 }}
                                    renderSeparator={<span style={{ marginRight: 5, marginLeft: 5 }}>-</span>}
                                    renderInput={(props) => <input {...props} />}
                                />
                            </div>
                            <span className="w-100 d-flex justify-content-center mt-2">Sent email verification code to your email</span>
                            <Button variant="primary" onClick={handleVerify} className="w-100 mt-4" disabled={otp.length !== 6}>
                                Verify
                            </Button>
                        </Container>
                        : <Form>
                            <Form.Group className="">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    type="text"
                                    defaultValue={email}
                                    onChange={(e: any) =>
                                        setEmail(e.target.value)
                                    }
                                />
                            </Form.Group>
                            <Form.Group className="mt-3">
                                <Form.Label>Password</Form.Label>
                                <Form.Control
                                    type="password"
                                    defaultValue={password}
                                    onChange={(e: any) =>
                                        setPassword(e.target.value)
                                    }
                                />
                            </Form.Group>
                            {
                                showSignUp && <Form.Group className="mt-3">
                                    <Form.Label>Confirm Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        defaultValue={confirmPassword}
                                        onChange={(e: any) =>
                                            setConfirmPassword(e.target.value)
                                        }
                                    />
                                </Form.Group>
                            }
                        </Form>
                }


            </Modal.Body>
            {
                !showOtp &&
                <Modal.Footer>
                    <Stack
                        direction="horizontal"
                        className="w-100 flex justify-content-center"
                    >
                        {
                            showSignUp ?
                                <Button variant="success" onClick={handleSignUp} className="w-100">
                                    Sign Up
                                </Button>
                                :
                                <Button variant="primary" onClick={handleSignInHandler} className="w-100">
                                    Sign In
                                </Button>
                        }
                    </Stack>
                    {
                        showSignUp ?
                            <Button variant="link" onClick={() => setShowSignUp(false)}>
                                Sign In
                            </Button>
                            : <Button variant="link" onClick={() => setShowSignUp(true)}>
                                Create a new one
                            </Button>
                    }
                </Modal.Footer>
            }
        </Modal>
    );
}
